import { __decorate } from "tslib";
import Avatar from '@/components/Avatar.vue';
import Modal from "@/components/Modal.vue";
import Roots from '@/components/Tooth/Roots.vue';
import Uploader from '@/components/Uploader.vue';
import Notes from '@/Pages/People/Customer/Notes.vue';
import MediaViewModal from '@/components/MediaViewModal.vue';
import XrayModal from '@/Pages/People/Customer/XrayModal.vue';
import ToothTreatments from '@/components/Tooth/Treatments.vue';
import { modalMixins } from '@/mixins/modal.js';
import { mapActions, mapGetters } from 'vuex';
import xrayType from '@/filters/xrays.js';
import { Component, Prop, Vue } from "vue-property-decorator";
import Tabs from "@/components/Tabs.vue";
// noinspection TypeScriptCheckImport
let Single = class Single extends Vue {
    id;
    customerId;
    tooth = null;
    loaded = false;
    tab = 'general';
    tabs = [];
    fetchImages;
    fetchXrays;
    fetchToothExams;
    findMediaInStore;
    findXraysInStore;
    findExamsInStore;
    getCustomer;
    openModal;
    created() {
        this.tabs = [
            { value: 'general', text: this.$t('General') },
            { value: 'others', text: this.$t('Others') }
        ];
    }
    get params() {
        return {
            query: {
                tooth: this.tooth,
                customerId: this.customerId
            }
        };
    }
    get title() {
        let fullName = this.customer.first_name + ' ' + this.customer.last_name;
        if (!this.tooth)
            return fullName;
        return this.$t('Tooth #') + this.tooth.toString() + '  / ' + fullName;
    }
    get customer() {
        return this.getCustomer(this.customerId);
    }
    get frontToothLoader() {
        console.log('currentToothLoader', this.tooth); // DO NOT REMOVE THIS LINE , I DON'T WHY !!!
        return () => import(`@/components/Teeth/Front/${this.tooth}`);
    }
    get oralToothLoader() {
        console.log('currentToothLoader', this.tooth); // DO NOT REMOVE THIS LINE , I DON'T WHY !!!
        return () => import(`@/components/Teeth/Oral/${this.tooth}`);
    }
    get exams() {
        return this.findExamsInStore(this.params).data;
    }
    get fileData() {
        let data = {
            customerId: this.customerId,
            tags: ['Tooth'],
            category: 'media'
        };
        if (this.tooth)
            data.tooth = Number(this.tooth);
        return data;
    }
    get xrayDefaults() {
        return {
            customerId: this.customerId,
            quantity: 1,
            type: 'intraoral',
            tooth: this.tooth,
        };
    }
    get images() {
        return this.findMediaInStore({
            query: {
                customerId: this.customerId,
                tooth: this.tooth,
                category: { $ne: 'xrays' }
            }
        }).data;
    }
    get xrays() {
        return this.findXraysInStore({
            query: {
                customerId: this.customerId,
                tooth: this.tooth,
                $sort: { createdAt: -1 }
            }
        }).data;
    }
    newExam(exam) {
        let toothItem = {
            tooth: this.tooth,
            exam: exam,
            _id: 'temp'
        };
        const { Exam } = this.$FeathersVuex;
        new Exam(toothItem);
        this.openModal({
            id: 'examModal',
        });
    }
    xrayType(type) {
        return xrayType(type);
    }
    hidden() {
        this.tooth = null;
        this.loaded = false;
    }
    shown() {
        const { Treatment } = this.$FeathersVuex;
        let data = Treatment.getFromStore('temp');
        if (data) {
            delete data._id;
            this.tooth = data.tooth === null ? null : parseInt(data.tooth);
            new Treatment({
                model: {},
                _id: 'temp'
            });
        }
        this.tab = 'general';
        this.loaded = false;
        Promise.all([
            this.fetchImages(this.params),
            this.fetchXrays(this.params),
            this.fetchToothExams(this.params),
        ]).finally(() => {
            this.loaded = true;
        });
    }
};
__decorate([
    Prop(String)
], Single.prototype, "id", void 0);
__decorate([
    Prop(String)
], Single.prototype, "customerId", void 0);
Single = __decorate([
    Component({
        components: {
            Tabs,
            Modal,
            Notes,
            Roots,
            Avatar,
            Uploader,
            XrayModal,
            MediaViewModal,
            ToothTreatments,
        },
        mixins: [modalMixins],
        methods: {
            ...mapActions('media', { fetchImages: 'find' }),
            ...mapActions('xrays', { fetchXrays: 'find' }),
            ...mapActions('exam', { fetchToothExams: 'find' }),
        },
        computed: {
            ...mapGetters('media', { findMediaInStore: 'find' }),
            ...mapGetters('xrays', { findXraysInStore: 'find' }),
            ...mapGetters('exam', { findExamsInStore: 'find' }),
            ...mapGetters('customers', { getCustomer: 'get' }),
        }
    })
], Single);
export default Single;
